import axios from './configAxios';

export const getOneEntrieApi = async ({ terminal_pk, order_pk, pass_pk }) => {
	return await axios.get(`/${terminal_pk}/${order_pk}/${pass_pk}/`);
};
